import { Row } from 'antd';
import React, { useState } from 'react';
import PageTitle from 'shared_components/page_title';
import DropDown from '../shared/dropdown';

//table components
import Hospital from './tables/hospital/index.jsx';
import Specimens from './tables/specimens/index.jsx';
import UnitOfMeasure from './tables/unit_of_measure/index.jsx';
import WardsAndRooms from './tables/ward_and_rooms';
import Section from './tables/section';
import Analyzer from './tables/analyzer';
import CheckInLocation from './tables/check-in_location';
import Physician from './tables/physician';

function index() {
	const tables = [
		// { label: 'Hospital', value: 'hospital' },
		{ label: 'Specimens', value: 'specimens' },
		{ label: 'Units of Measures', value: 'units-of-Measures' },
		{ label: 'Wards and rooms', value: 'wards-and-rooms' },
		{ label: 'Check-In Location', value: 'check-in-location' },
		{ label: 'Sections', value: 'sections' },
		{ label: 'Analyzer', value: 'analyzer' },
		{ label: 'Physician', value: 'physician' },
	];

	const [selectedSection, setSelectedSection] = useState('Wards and rooms');

	console.log(selectedSection);

	return (
		<>
			<Row justify="center" style={{ marginTop: 30 }}>
				<PageTitle pageTitle="LOOK-UP TABLES" />
			</Row>
			<Row justify="center">
				<DropDown
					placeholder="Select Section"
					content={tables}
					onChange={setSelectedSection}
					// loading={isInitializing}
					value={selectedSection}
				/>
			</Row>
			{selectedSection === 'hospital' ? (
				<Hospital />
			) : selectedSection === 'specimens' ? (
				<Specimens />
			) : selectedSection === 'units-of-Measures' ? (
				<UnitOfMeasure />
			) : selectedSection === 'wards-and-rooms' ? (
				<WardsAndRooms />
			)  : selectedSection === 'sections' ? (
				<Section />
			) : selectedSection === 'analyzer' ? (
				<Analyzer />
			): selectedSection === 'check-in-location' ? (
				<CheckInLocation />
			): selectedSection === 'physician' ? (
				<Physician />
			) : (
				<WardsAndRooms />
			)}
		</>
	);
}

export default index;
